/* global axios */
import ApiClient from '../ApiClient';

class AssistantScenarios extends ApiClient {
  constructor() {
    super('assistant/agents', { accountScoped: true });
  }

  // Сценарии — общий каталог аккаунта (Р8.1/Р9 п.7): без agentId работаем с
  // верхнеуровневым ресурсом, с agentId — со связками конкретного агента.
  scenariosUrl(agentId) {
    return agentId
      ? `${this.url}/${agentId}/scenarios`
      : this.url.replace(/\/agents$/, '/scenarios');
  }

  get({ agentId } = {}) {
    return axios.get(this.scenariosUrl(agentId));
  }

  // Лёгкий список для мультиселекта в форме агента (id/title/enabled).
  getAll() {
    return axios.get(this.scenariosUrl(null), { params: { slim: 1 } });
  }

  show({ agentId, id }) {
    return axios.get(`${this.scenariosUrl(agentId)}/${id}`);
  }

  create({ agentId, ...data } = {}) {
    return axios.post(this.scenariosUrl(agentId), { scenario: data });
  }

  update({ agentId, id }, data = {}) {
    return axios.patch(`${this.scenariosUrl(agentId)}/${id}`, {
      scenario: data,
    });
  }

  delete({ agentId, id }) {
    return axios.delete(`${this.scenariosUrl(agentId)}/${id}`);
  }
}

export default new AssistantScenarios();
